import { AppModal } from 'shared/UI/UIKit/Modal';
import type { RoomModalProps } from '../../types';
import { RoomForm } from '../../../Form/ui/RoomForm';
import { useEditService } from '../model';
import { RoomModalFooter } from '../../Footer';

interface EditRoomModalProps extends RoomModalProps {
  buildingId: number;
  onItemEdit: () => void;
}

export const EditRoomModal = ({
  selectedRoom,
  visible,
  hide,
  buildingId,
  onItemEdit,
}: EditRoomModalProps) => {
  const {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  } = useEditService({ hide, onItemEdit, buildingId, selectedRoom });

  const footer = <RoomModalFooter onSubmit={onSubmit} hideModal={hideModal} title="Сохранить" />;
  const content = <RoomForm form={form} />;

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      maskClosable={false}
      title="Редактировать аудиторию"
    />
  );
};
